"use client";

import { useState } from "react";

import { LinkButton } from "@/components/links/LinkButton";
import { NormalText } from "@/components/text/NormalText";
import { renewStripeSubscriptionAction } from "@/data/payment/actions/renewStripeSubscriptionAction";
import { UserNoDates } from "@/types/types";
import { formatDateForOutput } from "@/utils/formatTime/formatDateForOutput";
import { useIsClient } from "@/utils/hooks/useIsClient";
import { logError } from "@/utils/logError";
import { isFreeUser } from "@/utils/subscriptionLevels/isFreeUser";

export function RenewSubscriptionBanner({
  user,
}: {
  user: UserNoDates | null;
}) {
  const isClient = useIsClient();
  const [isLoading, setIsLoading] = useState(false);

  if (
    !(
      user !== null &&
      !isFreeUser(user.stripeSubscriptionId) &&
      user.stripeSubscriptionCancelAtPeriodEnd &&
      user.stripeSubscriptionEndTimestampString !== null
    )
  ) {
    return null;
  }

  const renewSubscription = async () => {
    setIsLoading(true);
    try {
      await renewStripeSubscriptionAction();
    } catch (error) {
      logError(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex flex-col justify-center gap-x-10 gap-y-2 bg-primaryLight px-6 py-2.5 sm:flex-row sm:px-3.5">
      <NormalText elementType="span">
        Subscription not renewing automatically. You'll lose your conversion
        time and paid features on{" "}
        {isClient &&
          formatDateForOutput({
            date: new Date(user.stripeSubscriptionEndTimestampString),
            withTime: false,
            withYear: false,
          })}
        .
      </NormalText>

      <LinkButton
        onClick={renewSubscription}
        className="flex items-center whitespace-nowrap"
        loading={isLoading}
      >
        Renew →
      </LinkButton>
    </div>
  );
}
